export * from './packages/icon/icon.js';
export * from './packages/tooltip/tooltip.js';
export * from './packages/textfield/textfield.js';
export * from './packages/affix/affix.js';
export * from './packages/alert/alert.js';
export * from './packages/link/link.js';
export * from './packages/button/button.js';
export * from './packages/attention/attention.js';
export * from './packages/badge/badge.js';
export * from './packages/box/box.js';
export * from './packages/breadcrumb-item/breadcrumb-item.js';
export * from './packages/breadcrumbs/breadcrumbs.js';
export * from './packages/card/card.js';
export * from './packages/checkbox/checkbox.js';
export * from './packages/checkbox-group/checkbox-group.js';
export * from './packages/combobox/combobox.js';
export * from './packages/datepicker/datepicker.js';
export * from './packages/expandable/expandable.js';
export * from './packages/modal/modal.js';
export * from './packages/modal-footer/modal-footer.js';
export * from './packages/modal-header/modal-header.js';
export * from './packages/page-indicator/page-indicator.js';
export * from './packages/pagination/pagination.js';
export * from './packages/pill/pill.js';
export * from './packages/radio/radio.js';
export * from './packages/radio-group/radio-group.js';
export * from './packages/select/select.js';
export * from './packages/slider-thumb/slider-thumb.js';
export * from './packages/slider/slider.js';
export * from './packages/snackbar-item/snackbar-item.js';
export * from './packages/snackbar/snackbar.js';
export * from './packages/step/step.js';
export * from './packages/step-indicator/step-indicator.js';
export * from './packages/switch/switch.js';
export * from './packages/tab/tab.js';
export * from './packages/tab-panel/tab-panel.js';
export * from './packages/tabs/tabs.js';
export * from './packages/textarea/textarea.js';
export * from './packages/toast/toast.js';
export * from './packages/toast-container/toast-container.js';
Promise.all([customElements.whenDefined('w-icon'),customElements.whenDefined('w-tooltip'),customElements.whenDefined('w-textfield'),customElements.whenDefined('w-affix'),customElements.whenDefined('w-alert'),customElements.whenDefined('w-link'),customElements.whenDefined('w-button'),customElements.whenDefined('w-attention'),customElements.whenDefined('w-badge'),customElements.whenDefined('w-box'),customElements.whenDefined('w-breadcrumb-item'),customElements.whenDefined('w-breadcrumbs'),customElements.whenDefined('w-card'),customElements.whenDefined('w-checkbox'),customElements.whenDefined('w-checkbox-group'),customElements.whenDefined('w-combobox'),customElements.whenDefined('w-datepicker'),customElements.whenDefined('w-expandable'),customElements.whenDefined('w-modal'),customElements.whenDefined('w-modal-footer'),customElements.whenDefined('w-modal-header'),customElements.whenDefined('w-page-indicator'),customElements.whenDefined('w-pagination'),customElements.whenDefined('w-pill'),customElements.whenDefined('w-radio'),customElements.whenDefined('w-radio-group'),customElements.whenDefined('w-select'),customElements.whenDefined('w-slider-thumb'),customElements.whenDefined('w-slider'),customElements.whenDefined('w-snackbar-item'),customElements.whenDefined('w-snackbar'),customElements.whenDefined('w-step'),customElements.whenDefined('w-step-indicator'),customElements.whenDefined('w-switch'),customElements.whenDefined('w-tab'),customElements.whenDefined('w-tab-panel'),customElements.whenDefined('w-tabs'),customElements.whenDefined('w-textarea')]).then(() => {
    performance.mark('vend/pc-design-system/warp-elements-loaded');
});
import './packages/global.js';
